import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import logo from "../assets/logo.svg";
// import CustomLoader from "../components/CustomeLoader";
import {
  Elements,
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { toast } from "react-toastify";
const CheckoutForm = ({ price_id, subscriptionId, planId }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token");
  const stripe = useStripe();
  const elements = useElements();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [installing, setInstalling] = useState(false);
  // const [loading, setLoader] = useState(true);
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (code == "") {
      if (!stripe || !elements) return;

      const result = await stripe.confirmPayment({
        elements,
        confirmParams: {},
        redirect: "if_required",
      });

      if (result.error) {
        //   alert.error(result.error.message);
        //   setDisabled(false);
      } else {
        fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/update-payment-status`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              plan_id: planId,
              paymentIntent: result?.paymentIntent?.id,
              price_id: price_id,
              subscription_id: subscriptionId,
            }),
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (
              window.ReactNativeWebView &&
              window.ReactNativeWebView.postMessage
            ) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify(data.result.billingId)
              );
            }
          })
          .catch((err) => {
            alert(err.message);
          });
      }
    } else {
      let result = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/redeem`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            code: code,
            plan_id: planId,
          }),
        }

      );

      result = await result.json();
      console.log(result);

      if (result.Status !== 200) {
        toast.error(result.Message);
      } else {
        toast.success(result.Message);
        if (
          window.ReactNativeWebView &&
          window.ReactNativeWebView.postMessage
        ) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify(result.Result.billingId)
          );
        }
      }
    }
    startInstall();
  };
  const startInstall = () => {
    setInstalling(true);
    setTimeout(() => setInstalling(false), 2000);
  };
  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoader(false);
  //   }, 1000);
  // }, []);
  return (
    <>
    <div className="main-container">
        <div className="container">
          <div className="logo">
            <img src={logo} alt="logo" />
          </div>
        </div>
        <form onSubmit={handleSubmit} className="payment-form">
          <PaymentElement className="payment-elements" />

          <div className="code-container"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "96%",
              margin: "auto",
              height: "auto",
            }}
          >
            <input
              type="text"
              style={{ width: "100%", borderRadius: 5, padding: 10 }}
              placeholder="Promotional Code"
              name="code"
              value={code}
              className="form-control"
              onChange={(e) => {
                if (e.target.value == "") {
                  setError("Please fill promotional code field");
                } else if (e.target.value.length < 3) {
                  setError("Promotional code must be 3 characters long");
                } else {
                  setError("");
                }
                setCode(e.target.value.toUpperCase());
              }}
            />
            <p style={{ color: "red", fontSize: 13, marginBottom: 0, paddingTop: 5 }}>{error}</p>
          </div>
          <button type="submit" className="payment-button" disabled={!stripe}>
            Pay
          </button>
        </form>
        {installing && (
          <div style={overlayStyle}>
            <div style={cardStyle}>
              <div style={spinnerStyle} aria-label="Installing…" />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CheckoutForm;


const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(10,18,40,.72)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  backdropFilter: "blur(2px)",
};
const cardStyle = {
  maxWidth: "90vw",
  // background: "#0f1d3a",
  // color: "#fff",
  // borderRadius: 16,
  padding: 20,
  // boxShadow: "0 10px 30px rgba(0,0,0,.4)",
  textAlign: "center",
  margin: "auto",
};
const spinnerStyle = {
  width: 40,
  height: 40,
  borderRadius: "50%",
  border: "4px solid rgba(255,255,255,.2)",
  borderTopColor: "#fff",
  animation: "spin 1s linear infinite",
};
